import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { useContext } from "react";
import { BookingFormContext } from "~/components/booking/ContextProvider";
import { useDebouncedState } from "~/utils/hooks/use-debounced-state";

export const PhoneInput = () => {
  const context = useContext(BookingFormContext);
  if (!context) {
    throw new Error("BookingFormContext is not provided");
  }

  const { phone, setPhone } = context;

  const [value, setValue] = useDebouncedState(phone, setPhone);

  return (
    <div className="grid w-full items-center gap-1.5 px-6">
      <Label htmlFor="phone">Phone Number *</Label>
      <div className="mt-2" />
      <div className="relative w-full">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <span className="text-gray-500 sm:text-sm">+44</span>
        </div>
        <Input
          type="tel"
          id="phone"
          placeholder="Phone Number"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          className="pl-12"
        />
      </div>
    </div>
  );
};
